import { createPortal } from "react-dom";
import { getPortalLayerTarget } from "./portalRoot";

const Portal = ({ children, layer = "modal" }) => {
  if (typeof document === "undefined" || !children) return null;

  // Modals escape #root glass so they cover header + sidebars.
  // Toast/picker also mount on body (via getPortalLayerTarget) so their
  // z-index can sit above body-portaled modals (1300 < 1350/1400).
  if (layer === "modal") {
    return createPortal(children, document.body);
  }

  const target = getPortalLayerTarget(layer);
  if (!target) return null;
  return createPortal(children, target);
};

export default Portal;
